let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("20Ni3")).then(() => parcelRequire('buXT4'));